module.exports = __webpack_public_path__ + "static/media/portfolio1 (5).929fe09a.jpeg";